<template>
  <div
    class="flex flex-col bg-white/20 backdrop-blur-sm p-4 rounded-xl"
  >
    <!-- Área do logo -->
    <div class="w-full grid place-items-center p-32">
      <q-skeleton
        type="rect"
        class="w-3/4 h-[7.5rem] rounded-lg"
        animation="wave"
      />
    </div>
    <!-- Área de conteúdo -->
    <div
      class="flex-1 flex flex-col gap-16 bg-white/20 rounded-lg p-20"
    >
      <!-- Título -->
      <q-skeleton type="text" class="w-3/4 h-20" animation="wave" />
      <q-skeleton type="text" class="w-1/2 h-16" animation="wave" />
      <!-- Botão -->
      <q-skeleton
        type="rect"
        class="w-full h-40 rounded-lg mt-auto"
        animation="wave"
      />
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
